import type { EntityType } from "@config";
import type { StoryStateType } from "../types";

export const syncAnchorsForCreatedEntities = (
  state: StoryStateType,
  newEntities: Record<string, EntityType>,
): void => {
  if (!state.story) return;
  const anchors = state.story.settings.anchors ?? {};
  state.story.settings.anchors = anchors;

  const existingValues = new Set(Object.values(anchors));

  for (const entity of Object.values(newEntities)) {
    if (!entity.settings?.isAnchorActive || !entity.settings?.anchorName)
      continue;

    let name = entity.settings.anchorName as string;
    if (existingValues.has(name)) {
      let counter = 1;
      while (existingValues.has(`${name}-${counter}`)) counter++;
      name = `${name}-${counter}`;
      entity.settings.anchorName = name;
    }

    anchors[entity.id] = name;
    existingValues.add(name);
  }
};

export const cleanupAnchors = (
  state: StoryStateType,
  deletedEntities: Record<string, EntityType>,
): void => {
  if (!state.story?.settings?.anchors) return;
  const anchors = state.story.settings.anchors;
  for (const id of Object.keys(deletedEntities)) {
    if (anchors[id]) delete anchors[id];
  }
};
